import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import NewSubscriberRegistration from "../newSubscriber/NewSubscriberRegistration";
import useEmpanelment from "../newSubscriber/util/useEmpanelment";

const NewReg = (props) => {
  const [agentRefNumber, setAgentRefNumber] = useState("");
  const subscriberPAN =
    props?.location?.state && props?.location?.state?.pan
      ? props.location.state.pan
      : "";

  const token = useSelector((state) => state.authReducer.token);
  const { PAN } = useSelector((state) => state.profileReducer.profileData);

  useEffect(() => {
    if (PAN) {
      const arn = token.replace("ARN-", "");
      setAgentRefNumber(PAN + arn.padStart(8, "0"));
    }
  }, [PAN, token]);

  const popDetails = useEmpanelment(agentRefNumber);

  const registrationDetails = {
    step: {
      type: "NEW",
      no: 1,
      details: {
        agentRefNumber,
        popDetails,
        subscriberPAN,
      },
    },
    personalDetails: {},
    kycDetails: {},
    aadhaarDetails: {},
    fatcaDetails: {},
    bankDetails: {},
    nomineeList: {},
    npsSchemeDetails: {},
    npsFundChoices: {},
    ePranKit: {},
    kycKtrackDetails: {},
    summary: {},
    ackNumber: "",
    preview: {},
  };

  return (
    <NewSubscriberRegistration
      refId={agentRefNumber}
      pan={subscriberPAN}
      popDetails={popDetails}
      registrationDetails={registrationDetails}
    />
  );
};

export default NewReg;
